import React, { useState, useEffect, useRef } from "react";
import "./receipt.css";
import logo from "./img/edaplogo.png";
import QRCode from "qrcode";
import signature from "./img/signature.png";
import html2pdf from "html2pdf.js";
import { Delete, Download } from "react-feather";
import app from "./firebase.js";
import { getDatabase, ref, set, push, onValue, remove } from "firebase/database";

function Receipt() {
  const [formData, setFormData] = useState({
    Names: "",
    Faculty: "",
    Department: "",
    Class: "",
    Matricule: "",
    "Academic year": "",
    Amount: "",
    reason: "",
    source: "",
    date: "",
    ref: "",
    image: null,
  });

  const [receipts, setReceipts] = useState([]);
  const [showReceipt, setShowReceipt] = useState({});

  const db = getDatabase(app);

  // Load receipts from Firebase on component mount
  useEffect(() => {
    const receiptsRef = ref(db, "receipts/UND/");
    onValue(receiptsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const receiptArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setReceipts(receiptArray);
      }
    });
  }, [db]);

  const handleChange = async (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prevData) => ({
          ...prevData,
          [name]: reader.result, // Save Base64 string of the image
        }));
      };
      if (file) reader.readAsDataURL(file);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleCreateReceipt = () => {
    if (formData.Names.trim() === "" || formData.Matricule.trim() === "") {
      alert("Name and Matricule fields cannot be empty!");
      return;
    }

    const newReceipt = { ...formData };
    setReceipts([...receipts, newReceipt]);
    const db = getDatabase(app);
    const receiptRef = ref(db, `receipts/UND/${formData.Matricule}`); // Save under matricule key

    set(receiptRef, {
      ...newReceipt,
    })
      .then(() => {
        console.log('Receipt saved successfully in Firebase');
      })
      .catch((error) => {
        console.error('Error saving receipt to Firebase: ', error);
      });

    setShowReceipt((prev) => ({ ...prev, [formData.Names]: false }));
    setFormData({
      Names: "",
      Faculty: "",
      Department: "",
      Class: "",
      Matricule: "",
      "Academic year": "",
      Amount: "",
      reason: "",
      source: "",
      date: "",
      ref: "",
      image: null,
    });
  };


  const handleDeleteReceipt = (id) => {
    const receiptRef = ref(db, `receipts/UND/${id}`);
    remove(receiptRef)
      .then(() => {
        console.log("Receipt deleted successfully from Firebase");
      })
      .catch((error) => {
        console.error("Error deleting receipt from Firebase: ", error);
      });
  };

  const toggleReceiptView = (name) => {
    setShowReceipt((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <div className="recu">
      <div className="page-image">
        <img src={logo} alt="University Logo" />
      </div>
      <div>
        <input
          className="finput"
          type="text"
          name="Names"
          placeholder="Nom et prenom"
          value={formData.Names}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Faculty"
          placeholder="Faculty"
          value={formData.Faculty}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Department"
          placeholder="Department"
          value={formData.Department}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Class"
          placeholder="Class"
          value={formData.Class}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Matricule"
          placeholder="Matricule"
          value={formData.Matricule}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Academic year"
          placeholder="Anée Académique"
          value={formData["Academic year"]}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Amount"
          placeholder="Montant"
          value={formData.Amount}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="reason"
          placeholder="Motif"
          value={formData.reason}
          onChange={handleChange}
        />
        {/* <input
          className="finput"
          type="text"
          name="source"
          placeholder="Source de paiement (ex: Western Union)"
          value={formData.source}
          onChange={handleChange}
        /> */}
        <input
          className="finput"
          type="date"
          name="date"
          placeholder="Date"
          value={formData.date}
          onChange={handleChange}
        />
        <br />
        {/* <input
          className="finput"
          type="text"
          name="ref"
          placeholder="N° de Reference"
          value={formData.ref}
          onChange={handleChange}
        /> */}
        <input
          className="finput"
          type="file"
          name="image"
          id="f-img"
          accept="image/*"
          onChange={handleChange}
        />
        <br />
        <div className="fbtn">
          <button className="fbutton" onClick={handleCreateReceipt}>
            Créer reçu
          </button>
        </div>
      </div>

      <div className="receipt-list">
        {receipts.map((receipt, index) => (
          <div key={receipt.id} className="receipt-item">
            <button
              className="receipt-toggle"
              onClick={() => toggleReceiptView(receipt.Names)}
            >
              {receipt.Names}
            </button>
            <button
              className="delete-btn"
              onClick={() => handleDeleteReceipt(receipt.id)}
            >
              <Delete size={15} />
            </button>
            {showReceipt[receipt.Names] && (
              <div>
                <ReceiptTemplate formData={receipt} />
                <button
                  className="downbtn"
                  onClick={() => downloadPDF(receipt.Names)}
                >
                  Telecharger <Download size={15} />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const ReceiptTemplate = ({ formData }) => {
  const now = new Date().toLocaleDateString();
  const qrCodeRef = useRef();

  useEffect(() => {
    const generateQRCode = async () => {
      const qrData = `
        Name: ${formData.Names}
        Faculty: ${formData.Faculty}
        Department: ${formData.Department}
        Class: ${formData.Class}
        Matricule: ${formData.Matricule}
        Amount: ${formData.Amount}
        Reason: ${formData.reason}
        Date: ${formData.date}
        Verification: Receipt Confirmed
      `;
      const qrCodeUrl = await QRCode.toDataURL(qrData);
      qrCodeRef.current.src = qrCodeUrl;
    };
    generateQRCode();
  }, [formData]);

  return (
    <div className="UND">
      <div className="recu-body" id={`receipt-${formData.Names}`}>
        <div className="school-pic">
          <div className="frecu">
            <h3>
              Université Nationale de la Decentralisation (UND)
            </h3>
            <img src={logo} alt="University Logo" />
            <p>
              Science - Action - Développement
              <br />
              <span>
                <strong>Status :</strong> Université publique
                <br />
                <strong>Web :</strong>  www.und.ac.ad
                <br />
                <strong>Email :</strong> info@und.ac.ad
              </span>
            </p>
          </div>
          {formData.image && (
            <img src={formData.image} alt="Student" className="stu-pic" />
          )}
        </div>
        <p className="stup">
          Reçu de : <strong>{formData.Names} </strong>
          la somme de: <strong>{formData.Amount} </strong>
          <br/>
          versée le <strong>{formData.date} </strong> pour :{" "}
           <strong>{formData.reason} </strong>  {/*à :{" "}
          <strong>{formData.source}</strong> N°/Ref <strong>{formData.ref}</strong>{" "} */}
          <br />
          a été vérifié et confirmé par le service de comptabilité UND/Unilis
           {/* le :{" "}
          <strong>{now}</strong> */}
          <br />
          <br />
          <br />
          {/* <div style={{display: "flex", marginBottom: "-15px"} }>
            <div>
              <span><b>Signature:</b></span>
            </div>
            <div>
              <img src={signature} width={100}/>
            </div>
          </div> */}
            {/* <span style={{marginTop: "-35px"}}>
              Nelly Merveille
              <br />
              Secrétaire-Comptable-Logistique du CIREP
            </span> */}
        </p>
        <div className="qr-container">
          <img ref={qrCodeRef} alt="QR Code" className="qr-code" />
        </div>
      </div>
    </div>
  );
};

const downloadPDF = (name) => {
  const element = document.getElementById(`receipt-${name}`);
  const options = {
    margin: 1,
    filename: `${name}_receipt.pdf`,
    html2canvas: { scale: 2, x : -2, y: 0, backgroundColor: "none" },
    jsPDF: { format: "a4", orientation: "portrait" },
  };
  html2pdf().set(options).from(element).save();
};

export default Receipt;
